import { cn } from "$/lib/utils/functions/misc.functions";
import { useMemo } from "react";
import Flexbox from "../../common/Flexbox";
import GraphFilterItem, { type GraphFilterItemsProps } from "./GraphFilterItem";

type Props = {
  title?: string;
  data: GraphFilterItemsProps[];
  unit?: string;
  row?: boolean;
  handleOnChange: (key: string, value: boolean) => void;
};

const GraphFilter = ({
  title,
  row = false,
  data,
  unit = " xx",
  handleOnChange,
}: Props) => {
  const dataWithIcon = useMemo(
    () => data.filter((item) => !(typeof item.isVisible === "undefined")),
    [data],
  );

  const dataWithoutIcon = useMemo(
    () => data.filter((item) => typeof item.isVisible === "undefined"),
    [data],
  );

  return (
    <Flexbox
      row={row}
      align={row ? "center" : undefined}
      fullWidth
      className="gap-1"
    >
      {title && (
        <p className="whitespace-nowrap text-base font-semibold text-secondary">
          {title}
        </p>
      )}

      <Flexbox
        className={cn({
          "overflow-x-auto": row,
          "max-h-[500px] gap-2 overflow-y-auto": !row,
        })}
      >
        <Flexbox row={row} className="gap-2">
          {dataWithoutIcon.map((item, index) => (
            <GraphFilterItem
              key={item.name + item.value}
              item={{ ...item, index }}
              unit={unit}
              fullWidth={!row}
              handleOnChange={handleOnChange}
            />
          ))}
        </Flexbox>
        <Flexbox row={row} align="stretch" className="gap-2">
          {dataWithIcon.map((item, index) => (
            <GraphFilterItem
              key={item.name + item.value}
              item={{ ...item, index }}
              unit={unit}
              fullWidth={!row}
              handleOnChange={handleOnChange}
            />
          ))}
        </Flexbox>
      </Flexbox>
    </Flexbox>
  );
};

export default GraphFilter;
